module.exports = __webpack_public_path__ + "static/media/serv-5.f4129c3d.jpg";